import Header from './components/Header';
import About from './components/About';
import Footer from './components/Footer';

import GlobalStyles from './components/styles/Global';

import { Flex } from './components/styles/Flex.style';
import { Button } from './components/styles/Button.style';
import { Image, StyledHeader } from './components/styles/Header.style';
import { Container, StyledShowcase } from './components/styles/Container.style';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Portfolio from './components/Portfolio';
import Services from './components/Services';
import ContactUs from './components/ContactUs';
import LogoSlider from './components/LogoSlider';
import Slider from './components/Slider';

const theme = {
	colors: {
		header: '#d6e0fa',
		primary: '#081740',
		body: '#fff',
		footer: '#081740',
		secondary: '#403108',
		white: '#F5F5F5',
		pictonBlue: '#374A81',
		golden: '#ff9900',
	},
	mobile: '858px',
	tab: '952px',
};

function App() {
	return (
		<Router>
			<ThemeProvider theme={theme}>
				<>
					<GlobalStyles />
					<Header />

					<Route
						path='/'
						exact
						render={(props) => (
							<>
								<StyledHeader>
									<Slider />{' '}
									<Container>
										<StyledShowcase>
											<Flex>
												<div>
													<h1>Safari ICT Solutions PLC</h1>
													<p>
														Safari ICT Solution is the result of dedication and
														hardworking professionals with exclusive purpose of
														technological excursion. Safari offer an
														unprecedented combination of work quality and
														apropos task delivery. For more than 5 years, we
														have designed, implemented, trained and maintained
														by means of ICT solutions that empower our business
														partners, exceed the expectations of the ICT
														professionals and elevate the users’ experience.
														What sets us different from our competitors is our
														expert workforce are well trained by our partners
														and national wide footprints of a team of
														professionals offering pre and post-sales support to
														our esteemed
													</p>

													<Button bg='#ff9900' color='#fff' href='#'>
														Get Started
													</Button>
												</div>
												<Image src='./images/Team-work.svg' />
											</Flex>
										</StyledShowcase>
									</Container>
								</StyledHeader>

								<LogoSlider />
							</>
						)}
					/>

					<Route path='/about' component={About} />

					<Route path='/services' component={Services} />

					<Route path='/portfolio' component={Portfolio} />

					<Route path='/contact' component={ContactUs} />

					<Footer />
				</>
			</ThemeProvider>
		</Router>
	);
}

export default App;
